import { Link } from 'react-router-dom';
import { useAnalysisNextQuery } from '../api/queries/next';
import { useAnalysisQuery } from '../api/queries/analysis';

export interface AnalysisNextProps {
  slug: string;
}

function getNextAnalysisLink(
  next: {
    analysisSchemaId: number;
    version: number;
  },
  slug: string
) {
  return `/?schemaId=${next.analysisSchemaId}&version=${next.version}&prefill=${slug}`;
}

export function AnalysisNext({ slug }: AnalysisNextProps) {
  const analysisQuery = useAnalysisQuery(slug);
  const analysisId = analysisQuery.data?.id;
  const analysisNextQuery = useAnalysisNextQuery(slug);

  if (!analysisNextQuery.data) {
    return <div>Loading...</div>;
  }

  if (analysisNextQuery.data.next.length === 0 || !analysisId) {
    return null;
  }

  return (
    <div className="p-8">
      <div className="border border-orange-2 p-4 bg-orange-100">
        <h2 className="text-2xl mb-4">Looking for next steps?</h2>
        {analysisNextQuery.data.next.map((next) => (
          <Link
            to={getNextAnalysisLink(next, slug)}
            key={`${next.analysisSchemaId}-${next.version}`}
            className="underline"
          >
            {next.name} v{next.version}
          </Link>
        ))}
      </div>
    </div>
  );
}
